// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"w6-z"};